import { useEffect, useState } from 'react';
import { api } from '../lib/api';

export default function Reviews() {
  const [reviews, setReviews] = useState([]);

  const load = () => api.getReviews().then(setReviews).catch((err) => console.error('Failed to load reviews:', err));
  useEffect(() => { load(); }, []);

  const updateStatus = async (id, status) => {
    try {
      await api.updateReview(id, { status });
      load();
    } catch (err) {
      console.error('Failed to update review:', err);
    }
  };

  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Reviews</h1>

      <div className="space-y-4">
        {reviews.map((review) => (
          <div key={review.id} className="bg-white rounded-lg shadow p-6">
            <div className="flex items-start justify-between mb-3">
              <div>
                <h3 className="font-medium text-gray-900">{review.guest_name}</h3>
                <p className="text-sm text-gray-500">{review.property_name} &middot; {review.platform}</p>
              </div>
              <span className={`px-2 py-1 rounded-full text-xs font-medium ${reviewStatusColor(review.status)}`}>
                {review.status}
              </span>
            </div>
            <p className="text-sm text-gray-700 bg-gray-50 rounded-md p-4 mb-4">{review.draft_text}</p>
            <div className="flex gap-2">
              {review.status === 'draft' && (
                <button onClick={() => updateStatus(review.id, 'pending_approval')} className="bg-blue-500 text-white px-3 py-1.5 rounded-md text-sm hover:bg-blue-600">
                  Submit for Approval
                </button>
              )}
              {review.status === 'pending_approval' && (
                <>
                  <button onClick={() => updateStatus(review.id, 'approved')} className="bg-green-500 text-white px-3 py-1.5 rounded-md text-sm hover:bg-green-600">
                    Approve
                  </button>
                  <button onClick={() => updateStatus(review.id, 'draft')} className="bg-gray-200 text-gray-700 px-3 py-1.5 rounded-md text-sm hover:bg-gray-300">
                    Send Back
                  </button>
                </>
              )}
              {review.status === 'approved' && (
                <button onClick={() => updateStatus(review.id, 'posted')} className="bg-green-600 text-white px-3 py-1.5 rounded-md text-sm hover:bg-green-700">
                  Mark as Posted
                </button>
              )}
            </div>
          </div>
        ))}
        {reviews.length === 0 && (
          <p className="text-gray-400 text-center py-12">No reviews yet</p>
        )}
      </div>
    </div>
  );
}

function reviewStatusColor(status) {
  const map = {
    draft: 'bg-gray-100 text-gray-800',
    pending_approval: 'bg-amber-100 text-amber-800',
    approved: 'bg-green-100 text-green-800',
    posted: 'bg-blue-100 text-blue-800',
  };
  return map[status] || 'bg-gray-100 text-gray-800';
}
